import React, {Component, PropTypes} from 'react';
import {
  Button,
  Modal,
  FormGroup,
  Form,
  Col,
  FormControl,
  ControlLabel,
} from '@sketchpixy/rubix';
import {ClipLoader} from 'react-spinners';
import {css} from 'react-emotion';

import {uploadPreSubscription} from '../../../api/api';

const override = css`
margin-top: -550px;
`;

class UploadExcelModal extends Component {
  constructor(props) {
    super(props);

    this.onFileChange = this.onFileChange.bind(this);

    this.state = {
      file:'',
      loading: false
    };
  }

  onFileChange(e) {
    this.setState({
      file: e.target.files[0],
    });
  }


    uploadPreSubscription = (event) => {
     let self = this;
     const formData = new FormData();
     if(self.state.file !== '')
     {
         formData.append('file',self.state.file);
     }

     self.setState({
         loading: true,
     });
      uploadPreSubscription(formData, (err, res) => {
         self.setState({
             loading: false,
         });
         if (err) {
            vex.dialog.alert('Failed to Upload!');
         } else if (res.statusCode != '0') {
             let message = res.statusMessage == '' ? 'Failed to upload!' : res.statusMessage;
             vex.dialog.alert(message);
         }else{
            vex.dialog.alert('Successfully uploaded!');
             this.props.closeModal(true);
         }
     });
  }

  onShowModal = (evt) => {

  }

  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            onEntered = {this.onShowModal}
            backdrop="static"
            style={{width:'100%'}}
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload Excel</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <Form>
                 <FormGroup controlId="formControlsFile">
                      <ControlLabel>Attach Excel</ControlLabel>
                      <FormControl type="file" name="file" onChange={this.onFileChange}/>
                 </FormGroup>
             </Form>
             <ClipLoader
             className={override}
             sizeUnit={'px'}
             size={500}
             color={'#123abc'}
             loading={this.state.loading}>
             </ClipLoader>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='primary' onClick={this.uploadPreSubscription}>Save</Button>
            <Button onClick={this.props.closeModal}>Cancel</Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

UploadExcelModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default UploadExcelModal;



// WEBPACK FOOTER //
// ./src/routes/product/components/UploadExcelModal.js